module.exports = __webpack_public_path__ + "img/dittoMarketingBanner.85e0f9f8.png";